import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

const { superior, subordinate, agency, region, sellerIn, login } = COMMON_FORM_FIELD_NAMES;

// only individual resolver settings fields
export const FIELDS = {
	radio: 'radio',
	superior,
	subordinate,
	agency,
	region,
	login,
	sellerIn,
	userFirstName: 'userFirstName',
	userSurname: 'userSurname',
};
